"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HotelBeachLine = _interopRequireDefault(require("./HotelBeachLine"));
var _HotelBeachSurface = _interopRequireWildcard(require("./HotelBeachSurface"));
var _HotelBeachDistance = _interopRequireDefault(require("./HotelBeachDistance"));
var _HotelAirportDistance = _interopRequireDefault(require("./HotelAirportDistance"));
var _HotelWiFiType = _interopRequireWildcard(require("./HotelWiFiType"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HotelCardFacts = function HotelCardFacts(_ref) {
  var line = _ref.line,
    beachSurface = _ref.beachSurface,
    beachDistance = _ref.beachDistance,
    airportDistance = _ref.airportDistance,
    wifiType = _ref.wifiType,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledHotelCardFacts, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledHotelBeachLine, {
    value: line
  }), /*#__PURE__*/_react["default"].createElement(_HotelBeachSurface["default"], {
    value: beachSurface
  }), /*#__PURE__*/_react["default"].createElement(StyledHotelBeachDistance, {
    value: beachDistance
  }), /*#__PURE__*/_react["default"].createElement(StyledHotelAirportDistance, {
    value: airportDistance
  }), wifiType && /*#__PURE__*/_react["default"].createElement(StyledHotelWiFiType, {
    value: wifiType
  }));
};
HotelCardFacts.propTypes = {
  className: _propTypes["default"].string,
  line: _propTypes["default"].number,
  beachSurface: _propTypes["default"].oneOf(Object.keys(_HotelBeachSurface.BEACH_SURFACE_TYPES)),
  beachDistance: _propTypes["default"].number,
  airportDistance: _propTypes["default"].number,
  wifiType: _propTypes["default"].oneOf(Object.keys(_HotelWiFiType.WIFI_TYPES))
};
HotelCardFacts.defaultProps = {
  line: null,
  beachSurface: null,
  beachDistance: null,
  airportDistance: null,
  wifiType: null
};
var StyledHotelBeachLine = (0, _styledComponents["default"])(_HotelBeachLine["default"]).withConfig({
  displayName: "HotelCardFacts__StyledHotelBeachLine",
  componentId: "sc-qnd7gx-0"
})(["width:50px;"]);
var StyledHotelBeachDistance = (0, _styledComponents["default"])(_HotelBeachDistance["default"]).withConfig({
  displayName: "HotelCardFacts__StyledHotelBeachDistance",
  componentId: "sc-qnd7gx-1"
})(["width:70px;"]);
var StyledHotelAirportDistance = (0, _styledComponents["default"])(_HotelAirportDistance["default"]).withConfig({
  displayName: "HotelCardFacts__StyledHotelAirportDistance",
  componentId: "sc-qnd7gx-2"
})(["width:50px;"]);
var StyledHotelWiFiType = (0, _styledComponents["default"])(_HotelWiFiType["default"]).withConfig({
  displayName: "HotelCardFacts__StyledHotelWiFiType",
  componentId: "sc-qnd7gx-3"
})(["width:50px;"]);
var StyledHotelCardFacts = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardFacts__StyledHotelCardFacts",
  componentId: "sc-qnd7gx-4"
})(["display:flex;cursor:default;"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelCardFacts);